<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            New Purchase order
            <v-icon right>add_circle</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromIssueDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromIssueDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toIssueDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toIssueDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="purchaseOrderStatusList"
                label="Choose Status ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete
                v-model="queryParams.supplierId"
                :items="supplierList"
                color="blue-grey lighten-2"
                :hide-no-data="true"
                label="Choose Supplier..."
                item-value="id"
                item-text="companyName"
                menu-props="auto"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete
                :items="currencyList"
                :hide-no-data="true"
                color="blue-grey lighten-2"
                label="Choose Currency..."
                item-value="id"
                item-text="code"
                menu-props="auto"
                v-model="queryParams.currencyId"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4 v-if="user.roleName == 'ADMIN' || user.roleName == 'BRANCH_ADMIN'">
              <v-autocomplete
                :items="warehouseList"
                :hide-no-data="true"
                color="blue-grey lighten-2"
                label="Choose Warehouse..."
                item-value="id"
                item-text="name"
                menu-props="auto"
                v-model="queryParams.warehouseId"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
          </v-card-title>
          <v-card-text class="font-weight-bold">
            <div>
              <span>Total Amount:</span>
              <v-chip>
                <span>{{ totalAmount | decFormat }}</span>
              </v-chip>
              <v-btn
                color="primary"
                :loading="printAllButtonLoading"
                @click="printAllPurchaseOrder('printAllPurchaseOrder')"
              >PRINT ALL</v-btn>
              <v-btn
                :loading="printAllButtonLoading"
                color="success"
                @click="exportAllPurchaseOrder()"
              >EXPORT ALL</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="purchaseOrderList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.issueDateInMilliSeconds | format-ms-date }}</td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.companyName }}</td>
              <td>{{ props.item.currencyCode }}</td>
              <td>{{ props.item.warehouseName }}</td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.totalUnitCost | decFormat }}</td>
              <td>{{ props.item.description }}</td>
              <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
              <td>{{ props.item.updatedBy }}</td>
              <td>
                <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <div id="printAllPurchaseOrder" style="bsale:1px solid black;width:300px;" v-show="false">
        <div style="text-align:center">
          <p style="font-size:18px;margin:1px">Purchase Order Report</p>
        </div>
        <div style="text-align:center">
        <p
          style="font-size:15px;margin:1px"
        >From Date: [{{this.queryParams.fromIssueDate | formatDate}}]      To Date: [{{this.queryParams.toIssueDate | formatDate}}]</p>
      </div>
       <div style="text-align:center">
        <p style="font-size:14px;margin:1px">Reported Date: [{{reportedDate}}]</p>
      </div>
        <br />
        <div style="padding-left:5px;padding-right:5px">
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;
          width: 100%;font-size:12px;border-top:1px solid black"
          >
            <thead style="border-bottom:1px solid black;border-top:1px solid black">
              <tr>
                <th style="border:1px solid black;text-align: center;">Issue Date</th>
                <th style="border:1px solid black;text-align: center;">Issue No</th>
                <th style="border:1px solid black;text-align:center">Supplier</th>
                <th style="border:1px solid black;text-align:center">Warehouse</th>
                <th style="border:1px solid black;text-align:center">Product Name</th>
                <th style="border:1px solid black;text-align:center">Unit</th>
                <th style="border:1px solid black;text-align:center">Currency</th>
                <th style="border:1px solid black;text-align:center">Price</th>
                <th style="border:1px solid black;text-align:center">Qty</th>
                <th style="border:1px solid black;text-align:center">Amount</th>
              </tr>
            </thead>
            <tbody v-for="(header, index) in allPurchaseOrderList" :key="index">
              <tr v-for="(item, i) in header.purchaseOrderItems" :key="i">
                <td style="border-left:1px solid black;text-align:left" v-if="i==0">{{ header.issueDateInMilliSeconds | format-ms-date }}</td>
                <td style="border-left:1px solid black;text-align:left" v-else></td>
                <td style="border-left:1px solid black;text-align:left" v-if="i==0">{{ header.issueNo }}</td>
                <td style="border-left:1px solid black;text-align:left" v-else></td>
                <td style="border-left:1px solid black;text-align:left" v-if="i==0">{{ header.companyName }}</td>
                <td style="border-left:1px solid black;text-align:left" v-else></td>
                <td style="border-left:1px solid black;text-align:left" v-if="i==0">{{ header.warehouseName }}</td>
                <td style="border-left:1px solid black;text-align:left" v-else></td>
                <td style="border:1px solid black;text-align:left">{{ item.productName  +  "(" + item.productCode + ")"}}</td>
                <td style="border:1px solid black;text-align:left">{{ item.factorUnitName}}</td>
                <td style="border-left:1px solid black;text-align: center;" v-if="i==0">{{ header.currencyCode }}</td>
                <td style="border-left:1px solid black;text-align:left" v-else></td>
                <td style="border:1px solid black;text-align:right">{{ item.unitCost | decFormat }}</td>
                <td style="border:1px solid black;text-align:right"> {{ item.qty }}</td>
                <td style="border:1px solid black;text-align:right"> {{ item.qty * item.unitCost | decFormat }}</td>
              </tr>
              <tr>
                <td style="border:1px solid black;font-weight:bold" colspan="8">Sub Total</td>
                <td style="border:1px solid black;font-weight:bold;text-align:right">{{ header.totalQty }}</td>
                <td style="border:1px solid black;font-weight:bold;text-align:right">{{ header.totalUnitCost | decFormat }}</td>
              </tr>
            </tbody>
            <tr>
              <td style="border:1px solid black;font-weight:bold" colspan="8">Grand Total</td>
              <td style="border:1px solid black;font-weight:bold;text-align:right"> {{ allTotalQty}}</td>
              <td style="border:1px solid black;font-weight:bold;text-align:right">{{ totalAmount  | decFormat }}</td>
            </tr>
          </table>
        </div>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import { purchaseOrderService } from "../../services/purchase-order-service";
// TODO: Add Supplier Service
import { currencyService } from "../../services/currency-service";
import { warehouseService } from "../../services/warehouse-service";
import { commonService } from "../../services/common-service";
import { supplierService } from "../../services/supplier-service";

export default {
  name: "PurchaseOrderList",

  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),

    issueDate: commonService.formatDate(
      new Date().toISOString().substr(0, 10),
      "YYYY-MM-DD"
    ),
    showListLoading: false,
    breadcrumbs: [
      {
        text: "Purchasing",
        disabled: true
      },
      {
        text: "Purchase Order",
        disabled: true
      }
    ],
    headers: [
      { text: "Issue Date", align: "left", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "Supplier", value: "supplier.companyName" },
      { text: "Currency", value: "currency.code" },
      { text: "Warehouse", value: "warehouse.name" },
      { text: "Status", value: "status" },
      { text: "Total Unit Cost", value: "totalAmount", sortable: false },
      { text: "Description", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
      { text: "Action", value: "action", sortable: false }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0
    },
    purchaseOrderStatusList: [
      { label: "----All----", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "QUOTATION", value: "QUOTATION" },
      { label: "FINISHED", value: "FINISHED" },
      { label: "CANCEL", value: "CANCEL" }
    ],
    purchaseOrderList: [],
    supplierList: [],
    currencyList: [],
    warehouseList: [],
    totalRows: 0,
    totalAmount: 0,
    allTotalQty: 0,
    allPurchaseOrderList: [],
    printAllButtonLoading: false,
    reportedDate: commonService.formatDate(new Date(), "DD/MM/YYYY"),
    decimalFormat: "",
    queryParams: {
      fromIssueDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toIssueDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      status: "",
      supplierId: "",
      currencyId: "",
      warehouseId: ""
    }
  }),
  watch: {
    pagination: {
      handler() {
        this.getPurchaseOrderList();
      },
      deep: true
    }
  },
  created() {
    //for deep linking
    if (this.user.roleName == "WAREHOUSE_MANAGER") {
      this.queryParams.warehouseId = this.user.warehouse.id;
    }
    if (this.$route.query.fromIssueDate) {
      this.queryParams.fromIssueDate = this.$route.query.fromIssueDate;
    }
    if (this.$route.query.toIssueDate) {
      this.queryParams.toIssueDate = this.$route.query.toIssueDate;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.supplierId) {
      this.queryParams.supplierId = this.$route.query.supplierId;
    }
    if (this.$route.query.currencyId) {
      this.queryParams.currencyId = this.$route.query.currencyId;
    }
    if (this.$route.query.warehouseId) {
      this.queryParams.warehouseId = this.$route.query.warehouseId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.rowsPerPage) {
      this.pagination.rowsPerPage = this.$route.query.rowsPerPage;
    }
    this.getSupplierList();
    this.getCurrencyList();
    this.getWarehouseList();
    //this.decimalFormat = commonService.formatdecimal();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.rowsPerPage = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "purchase-order",
        query: this.queryParams
      });
      this.getPurchaseOrderList();
    },
    getPurchaseOrderList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      purchaseOrderService
        .getPurchaseOrderList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.purchaseOrderList = res.data.data;
            this.totalRows = res.data.totalElements;
            this.totalAmount = res.data.totalAmount;
            this.allTotalQty = res.data.allTotalQty;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getSupplierList() {
      supplierService.getAllSupplier().then(res => {
        this.supplierList = res.data;
        let findAll = {
          id: "",
          companyName: "---All---"
        };
        this.supplierList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
      });
    },
    getCurrencyList() {
      currencyService
        .getAllCurrency()
        .then(res => {
          this.currencyList = res.data;
          let findAll = {
            id: "",
            code: "----All----"
          };
          this.currencyList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
        });
    },
    getWarehouseList() {
      warehouseService
        .getAllWarehouse()
        .then(res => {
          this.warehouseList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.warehouseList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
        });
    },
    exportAllPurchaseOrder() {
      this.printAllButtonLoading = false;
      purchaseOrderService
        .exportPurchaseOrderExcel(this.queryParams)
        .then(res => {
          commonService.downloadE(res);
        })
        .catch(err => {
          console.log(err);
        });
      this.printAllButtonLoading = false;
    },
    printAllPurchaseOrder(divName) {
      this.printAllButtonLoading = true;
      purchaseOrderService
        .getAllPurchaseOrderList(this.queryParams)
        .then(res => {
          if (res.data) {
            this.allPurchaseOrderList = res.data.data;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllButtonLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/purchase-order/new");
    },
    onEdit(data) {
      this.$router.push("/purchase-order/" + data.id);
    }
  }
};
</script>